<template>
    <span class="vrm-avatar-stack">
        <vrm-avatar
            v-for="(user, index) in visibleUsers"
            :key="user.id"
            :user="user"
            :style="overlapStyle(index)"
            :admin-key="adminKey"
        />
        <span v-if="hiddenCount" class="vrm-avatar-stack__hidden">+ {{ hiddenCount }}</span>
    </span>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmAvatar from '@/vue/components/shared/VrmAvatar';
import { AngularDirective } from '@/vue/decorators/angular-interop';
@Component({
    components: { VrmAvatar },
})
@AngularDirective('vrm-avatar-stack')
export default class VrmAvatarStack extends Vue {
    @Prop({ type: Array, default: () => [] })
    users;
    @Prop({ type: Number, default: 4 })
    max;
    @Prop({ type: String, default: undefined })
    adminKey;

    get visibleUsers() {
        return this.users.length > 4 ? this.users.slice(0, 4) : this.users;
    }

    get hiddenCount() {
        return this.users.length - this.visibleUsers.length;
    }

    overlapStyle(index) {
        return {
            zIndex: index,
        };
    }
}
</script>
